import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';

const Address = ({ data }) => (
  <Table borderless border="0" cellSpacing="0" cellPadding="0">
    <thead>
      <tr>
        <th colSpan="2">
          <div className="pagination-container">
            <h5>Address</h5>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td />
        <td>
          <span className="subheader">Business Address line 1:</span>
          <span>{data.addressLine1}</span>
          <span className="subheader">Business Address line 2:</span>
          <span>{data.addressLine2}</span>
          <span className="subheader">City:</span>
          <span className="text-transform-none">{data.city}</span>
          <span className="subheader">State:</span>
          <span>{data.state}</span>
          <span className="subheader">Zip:</span>
          <span>{data.zip}</span>
          <span className="subheader">Timezone:</span>
          <span>{data.timezone}</span>
        </td>
      </tr>
    </tbody>
  </Table>
);

Address.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default Address;
